import React, { useState, useEffect } from 'react';
import { Popover, Box, Typography, Stack, Select, MenuItem, Button } from '@mui/material';

export default function QuickCreatePopover({
  open,
  anchorEl,
  onClose,
  date,
  employee,
  defaultStartTime = '09:00',
  defaultEndTime = '13:00',
  roles = [],
  onCreateAssigned, // (role) => void
  onCreateOpen,     // (role) => void
  onMoreOptions,    // () => void
}) {
  const [role, setRole] = useState(employee?.role || roles[0] || '');

  // Update role when employee changes (auto-select their role)
  useEffect(() => {
    if (employee?.role) {
      setRole(employee.role);
    } else if (roles.length > 0) {
      setRole(roles[0]);
    }
  }, [employee, roles]);

  const formatDate = (d) => d?.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

  return (
    <Popover open={open} anchorEl={anchorEl} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
      <Box sx={{ p: 1.5, minWidth: 300 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>New Shift • {formatDate(date)} {defaultStartTime}–{defaultEndTime}</Typography>
        {employee && (
          <Typography variant="body2" color="text.secondary">Assign to {employee.first_name} {employee.last_name}</Typography>
        )}

        <Stack direction="row" spacing={1} sx={{ mt: 1, mb: 1 }} alignItems="center">
          <Typography variant="body2" sx={{ minWidth: 36 }}>Role</Typography>
          <Select size="small" value={role} onChange={(e)=>setRole(e.target.value)} displayEmpty sx={{ flex: 1 }}>
            {roles.map(r => (<MenuItem key={r} value={r}>{r}</MenuItem>))}
          </Select>
        </Stack>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
          {employee && (
            <Button size="small" variant="contained" onClick={() => { onClose?.(); onCreateAssigned?.(role); }}>
              Assign to {employee.first_name}
            </Button>
          )}
          <Button size="small" variant="outlined" onClick={() => { onClose?.(); onCreateOpen?.(role); }}>
            Create Open Shift
          </Button>
          <Button size="small" onClick={() => { onClose?.(); onMoreOptions?.(); }}>More options</Button>
        </Stack>
      </Box>
    </Popover>
  );
}

